const a = () => {
  throw new Error("test error");
};

export const DeliberatelyThrowsAnErrorPage = () => {
  const x = a();

  return <>Error {x}</>;
};
